import React from 'react';

const ArrowMinus = () => {
  return (
    <svg width="24" height="2" viewBox="0 0 24 2" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.7071 1.70711C23.8946 1.51957 24 1.26522 24 1C24 0.734784 23.8946 0.48043 23.7071 0.292893C23.5196 0.105357 23.2652 0 23 0H13H12H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1C0 1.26522 0.105357 1.51957 0.292893 1.70711C0.48043 1.89464 0.734784 2 1 2H11H23C23.2652 2 23.5196 1.89464 23.7071 1.70711Z"
        fill="#1E3E43"/>
    </svg>


  );
};

export default ArrowMinus;
